import { API } from 'aws-amplify'

import { CardCollectionDto, CreateCardCollectionDto, returnCardCollectionAndCategories, SubCategoriesWithQuizzesDto, } from 'types'

export const getCardCollections = async (): Promise<CardCollectionDto[]> => {
    return API.get('api', '/card-collections', {})
}

export const getCardCollectionById = async (cardCollectionId: string): Promise<SubCategoriesWithQuizzesDto> => {
    return API.get('open-api', `/v2/card-collections/${cardCollectionId}`, {})
}

export const createCardCollections = async ({ name, subCategories, jokerCard, createdBy, categories, grades, subjects }: CreateCardCollectionDto): Promise<string> => {
    return API.post('api', '/card-collections', { body: { name, subCategories, jokerCard, createdBy, categories, grades, subjects } })
}

export const updateCardCollections = async (cardCollectionId: string, { name, subCategories, jokerCard, createdBy, categories, grades, subjects }: CreateCardCollectionDto): Promise<CardCollectionDto> => {
    return API.put('api', `/card-collections/${cardCollectionId}`, { body: { name, subCategories, jokerCard, createdBy, categories, grades, subjects } })
}

export const deleteCardCollections = async (cardCollectionId: string): Promise<string> => {
    return API.del('api', `/card-collections/${cardCollectionId}`, {})
}